/* eslint-disable react-hooks/exhaustive-deps */
// noinspection JSIgnoredPromiseFromCall
import UrlConfig from '@/api/UrlConfigs'
import type { EnumDescription } from '@/pages/clueConfig/launchPlatform/interface'
import { ConfigItem, LaunchPlatform } from '@/pages/clueConfig/launchPlatform/interface'
import { optionsModal } from '@/pages/clueConfig/launchPlatform/modify/optionsModal'
// import { getDataDictionaries, getLaunchPlatform, updateLaunchPlatform } from '@/services/getUsers'
import { PlusOutlined } from '@ant-design/icons'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Switch,
  Table,
  message,
} from 'antd'
import zhCN from 'antd/lib/locale/zh_CN'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {SActionBtn, SDrawer, SDrawerOrModal, STableActions} from 'shj-components'
import { configModal } from './configModal'
const FormItem = Form.Item

export default function AddPage(props) {
  const { open, onClose, fn } = props
  const history = useNavigate()
  // const params = useParams();
  const id = props?.id
  const isEdit = () => !!id
  const [form] = Form.useForm()
  const { setFieldsValue } = form
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [data, setData] = useState<LaunchPlatform>(new LaunchPlatform())
  const [platformTypes, setPlatformTypes] = useState<EnumDescription[]>([])
  const [configItemTypes, setConfigItemTypes] = useState<EnumDescription[]>([])
  const [configItemTypeMap, setConfigItemTypeMap] = useState<Record<string, string>>({})
  const [configs, setConfigs] = useState<ConfigItem[]>([])

  const updateData = (newData: LaunchPlatform) => {
    setData(newData)
    setFieldsValue(newData)
  }
  useEffect(() => {
    initFn()
  }, [])
  const initFn = async () => {
    // const platformTypes = await getDataDictionaries(
    //   'com.shj.saas.clue.domain.account.enums.PlatformTypeEnum'
    // )
    // setPlatformTypes(platformTypes)
    // const typeMapData: EnumDescription[] = await getDataDictionaries(
    //   'com.shj.saas.clue.domain.account.enums.LaunchPlatformConfigItemType'
    // )
    // const typeMap = {}
    // typeMapData.forEach(type => (typeMap[type.key] = type.value))
    // setConfigItemTypes(typeMapData)
    // setConfigItemTypeMap(typeMap)
    // if (isEdit()) {
    //   getLaunchPlatform(id).then((res: any) => {
    //     const entity: any = res
    //     entity.platformTypes = JSON.parse(entity.platformTypes)
    //     updateData(entity)
    //     setConfigs(entity.configs)
    //   })
    // }
  }

  const onChange = (val: LaunchPlatform) => {
    setData({
      ...data,
      ...val,
    })
  }

  const onFinish = () => {
    form.validateFields().then((values: LaunchPlatform) => {
      let requestData: any = {
        ...data,
        ...values,
      }
      requestData.configs = configs
      requestData.platformTypes = JSON.stringify(requestData.platformTypes)
      if (!requestData.allowAuth) {
        requestData.allowAuth = false
      }
      setSubmitLoading(true)

      if (isEdit()) {
        requestData.id = id
        // updateLaunchPlatform(UrlConfig.Clue.LaunchPlatformUpdateById, requestData)
        //   .then(() => {
        //     message.info('编辑投放平台成功')
        //     setSubmitLoading(false)
        //     onClose()
        //     fn()
        //   })
        //   .catch(() => {
        //     setSubmitLoading(false)
        //   })
      } else {
        // updateLaunchPlatform(UrlConfig.Clue.LaunchPlatformOperate, requestData)
        //   .then(() => {
        //     message.info('添加投放平台成功')
        //     setSubmitLoading(false)
        //     onClose()
        //     fn()
        //   })
        //   .catch(() => {
        //     setSubmitLoading(false)
        //   })
      }
    })
  }

  // const onBack = useCallback(() => history(-1), []);

  const addConfig = () => {
    configModal({
      title: '新增配置',
      callback: config => {
        const newConfigs = [...configs]
        newConfigs.push(config)
        setConfigs(newConfigs)
      },
      record: new ConfigItem(),
      configKeys: configs.map(config => config.configKey),
      configItemTypes,
    })
  }

  const updateConfig = (config: ConfigItem, index: number) => {
    configModal({
      title: '编辑配置',
      callback: newConfig => {
        const newConfigs = [...configs]
        newConfigs[index] = newConfig
        setConfigs(newConfigs)
      },
      record: config,
      configKeys: configs
        .map(configItem => configItem.configKey)
        .filter(configKey => configKey !== config.configKey),
      configItemTypes,
    })
  }

  const removeConfig = (index: number) => {
    const newConfigs = [...configs]
    newConfigs.splice(index, index + 1)
    setConfigs(newConfigs)
  }

  const optionsConfig = (config: ConfigItem, index: number) => {
    optionsModal({
      callback: options => {
        const newConfig = { ...config }
        newConfig.options = options
        const newConfigs = [...configs]
        newConfigs[index] = newConfig
        setConfigs(newConfigs)
      },
      record: config.options,
    })
  }

  const configColumns = [
    {
      title: '配置Key',
      dataIndex: 'configKey',
      key: 'configKey',
      width: 200,
    },
    {
      title: '配置名',
      dataIndex: 'configName',
      key: 'configName',
      width: 200,
    },
    {
      title: '必填',
      dataIndex: 'required',
      key: 'required',
      width: 120,
      render: (required: boolean) => (required ? '是' : '否'),
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      width: 160,
      render: (type: string) => configItemTypeMap[type],
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 200,
      render: (text: any, record: ConfigItem, index: number) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <STableActions>
              {record.type === 'SELECT' && (
                <SActionBtn
                  primary={record.options.length === 0}
                  onClick={() => optionsConfig(record, index)}
                >
                  选项配置<i>({record.options.length}个选项)</i>
                </SActionBtn>
              )}
              <SActionBtn onClick={() => updateConfig(record, index)}>编辑</SActionBtn>
              <SActionBtn onClick={() => removeConfig(index)}>删除</SActionBtn>
            </STableActions>
          </div>
        )
      },
    },
  ]

  return (
    <SDrawerOrModal
      title={id ? '编辑key' : '新增key'}
      open={open}
      width={600}
      onCancel={onClose}
      mode={'modal'}
      destroyOnClose={true}
      onOk={onFinish}
      loading={submitLoading}
    >
      <div style={{ overflow: 'hidden' }}>
        <div className={'filter-table'}>
          <ConfigProvider locale={zhCN}>
            <Form
              form={form}
              autoComplete="off"
              onValuesChange={onChange}
              labelAlign={'right'}
              layout={'vertical'}
            >
              <div className={'shj-common-drag-table szyxy-common-drag-table'}>
                <div style={{ margin: 20 }}>
                      <FormItem label="选择平台" labelCol={{ span: 6 }} name="platformTypes"
                        rules={[{ required: true, message: '选择平台不能为空' }]}
                      >
                        <Select
                          placeholder="请选择选择平台"
                          mode={'multiple'}
                          
                          showSearch
                          filterOption={(input, option: any) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {platformTypes &&
                            platformTypes.map(item => (
                              <Select.Option key={item.key} value={item.key}>
                                {item.value}
                              </Select.Option>
                            ))}
                        </Select>
                      </FormItem>
                      <FormItem
                        label="应用key"
                        labelCol={{ span: 6 }}
                        name="platformCode"
                        rules={[{ required: true, message: '应用key不能为空' }]}
                      >
                        <Input placeholder="请输入应用key" disabled={isEdit()} />
                      </FormItem>
                      <FormItem
                        label="应用名称"
                        labelCol={{ span: 6 }}
                        name="platformName"
                        rules={[{ required: true, message: '应用名称不能为空' }]}
                      >
                        <Input placeholder="请输入应用名称" />
                      </FormItem>
                      <FormItem label="是否必填" labelCol={{ span: 6 }} name="allowAuth">
                        <Switch
                          checkedChildren="启用"
                          unCheckedChildren="禁用"
                          checked={data && data.allowAuth}
                        />
                      </FormItem>
                      <FormItem label="key类型" labelCol={{ span: 6 }} name="platformTypes"
                        rules={[{ required: true, message: 'key类型不能为空' }]}
                      >
                        <Select
                          placeholder="请选择key类型"
                          mode={'multiple'}
                          showSearch
                          filterOption={(input, option: any) =>
                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {platformTypes &&
                            platformTypes.map(item => (
                              <Select.Option key={item.key} value={item.key}>
                                {item.value}
                              </Select.Option>
                            ))}
                        </Select>
                      </FormItem>
                </div>
                {/* <div style={{ margin: 20 }}>
                  <Table
                    columns={configColumns}
                    dataSource={configs}
                    rowKey={'configKey'}
                    pagination={false}
                    bordered={true}
                  />
                </div>
                <div style={{ margin: 20 }}>
                  <Row gutter={12}>
                    <Col span={24}>
                      <FormItem>
                        <Button
                          type="dashed"
                          onClick={() => addConfig()}
                          block
                          icon={<PlusOutlined />}
                        >
                          添加配置项
                        </Button>
                      </FormItem>
                    </Col>
                  </Row>
                </div> */}
              </div>
            </Form>
          </ConfigProvider>
        </div>
      </div>
    </SDrawerOrModal>
  )
}
